import { getVideoData } from 'utils/video';

import { getAmpTagForVideoType } from './helpers/getAmpTagForVideoType';

type Props = {
  url: string;
};

export function AmpVideoPlayer({ url }: Props) {
  const videoData = getVideoData({ url });
  if (!videoData) return null;

  const VideoComponent = getAmpTagForVideoType(videoData.type);

  return (
    // @ts-expect-error amp-tags do not exist
    <VideoComponent
      src={videoData.type === 'raw' ? videoData.url : undefined}
      data-videoid={
        videoData.type === 'youtube' || videoData.type === 'vimeo'
          ? videoData.videoId
          : undefined
      }
      layout="responsive"
      width="480"
      height="270"
    />
  );
}
